<template>
  <div class="mainWeb">
    <el-row class="headTop">
      <span v-if="showShop">
        分店：<el-select class="w150 mr20" v-model="params.shopNum" clearable  placeholder="请选择分店">
          <el-option
          v-for="item in this.shopList"
          :key="item.shopNum"
          :label="item.name"
          :value="item.shopNum"
          ></el-option>
        </el-select>
        </span>
        会员卡名：<el-input
         class="w150 mr20"
          placeholder="请输入会员卡名"
          v-model="params.name"
          clearable>
        </el-input>
        <el-button style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
    </el-row>
    <el-tabs class="tabCard" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="线下卡" name="offLine">
        <offlineCard :tableDataOff="tableDataOff" :name="params.name" :shopNumChild="params.shopNum" @getTableDataOff="getTableDataOff"></offlineCard>
      </el-tab-pane>
      <el-tab-pane label="线上卡" name="onLine">
        <onlineCard :tableDataOn="tableDataOn" :name="params.name" :shopNumChild="params.shopNum"  @getTableDataOn="getTableDataOn"></onlineCard>
      </el-tab-pane>
    </el-tabs>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getCardsSell, cardAvailable, getShops, updateCardsSell, deletetOnlineCard, getCardShopList,getInfCs} from "../../api/configApi";
// import onlineCard from './onlineCard'
import offlineCard from './offlineCard'
import onlineCard from './onineCard'

import EditorBar from '../../components/wangEnduit'
export default {
  data() {
    return {
      activeName:'offLine',
      name:'offLine',
      loading: true,
      dialogVisible: false,
      showShop:false,
      showQuery: false,
      formparams:{
        cardName:'',
        cardShortName:'',
        weChatPrice:'',
        description:'',
        shopNum:'',
        maxSell:''
      },
      // 线下卡列表
      tableDataOff:[],
      //线上卡列表
      tableDataOn:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      cardshopList: [],
      total: 0,
      currentPage: 1,
      params: {
        name:null,
        shopNum:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  beforeCreate(){
    that = this
  },
  created(){
  },
  components:{
    onlineCard,
    EditorBar,
    offlineCard,
  },
  mounted() {
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
      if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
        this.params.shopNum = this.shopList[0].shopNum
        this.showShop = false
      }else{
        this.showShop = true
      }
    } else{
      this.getShopsList()
    }
    // this.getShopsList()
    this.getTableListOff()
  },
  methods: {
     // 查询卡可使用的分店
     getCardShopList(cardShortName) {
      getCardShopList({cardShortName}).then((res)=>{
        this.cardshopList = res.data
        console.log(res)
      })
    },
    handleClick(tab) {
      this.params.name =null
      this.params.shopNum =null
      this.params.pageNo = 1;
      this.params.pageSize = 20;
      if(tab.name == 'onLine'){
        this.name = 'onLine'
        this.getTableList()
      }else{
        this.name = 'offLine'
        this.getTableListOff()
      }
    },

    queryList(){
      if(this.name == 'onLine'){
        this.params.pageNo=1
        this.currentPage = 1
        this.getTableList()
      }else{
        this.params.pageNo=1
        this.currentPage = 1
        this.getTableListOff()
      }
    },
    getTableDataOff(data){
      this.tableDataOff = data.info
      this.total = data.total
    },
    getTableDataOn(data){
      this.tableDataOn = data.info
      this.total = data.total
    },
    //查询线下卡列表
    getTableListOff(){
      getInfCs(this.params).then((res)=>{
        if(res.msg=='success'){
          this.tableDataOff = res.data.info
          this.total = res.data.total
        } else {
          this.$message.error(res.data)
        }
        this.loading= false
      })
    },
     //查询卡列表
    getTableList(){
      getCardsSell(this.params).then((res)=>{
        if(res.msg=='success'){
          this.tableDataOn = res.data.info
          this.total = res.data.total          
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
      })
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      if(this.name == 'onLine'){
        this.getTableList()
      }else{
        this.getTableListOff()
      }
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      if(this.name == 'onLine'){
        this.getTableList()
      }else{
        this.getTableListOff()
      }
    },
  }
}
</script>
<style scoped lang="scss">
.tableList {
  width: 100%;
  margin-top: 20px;
  /* height: 73vh; */
  overflow-y: auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: none;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// cards.vue?4483a304